export const firebaseConfig = {
  apiKey: "AIzaSyDWRZayg9bTSXmgKPHayLXnbuAmbjvolW4",
  authDomain: "tidal-eye.firebaseapp.com",
  projectId: "tidal-eye",
  storageBucket: "tidal-eye.appspot.com",
  messagingSenderId: "565516444558",
  appId: "1:565516444558:web:34a6c4e345dbc048d8badf",
  measurementId: "G-74V0FD5VFH"
};

export const environment = {
  firebase: firebaseConfig,
  iconPath: 'assets/icon/favicon-tidal.png',
  production: true,
  prj: 'tidal',
};
